import packageJson from "../../package.json";

//Irrigator Data
export const APP_VERSION = packageJson.version;

/* Common values */
//MAP Fields Colors
export const AVAILABLE = "#36ED54"; //green
export const SELECTED = "#49B1F0"; //blue
export const REGISTERED = "#707B7C"; //grey
export const CLAIM = "#F83746"; //red
export const ADDED = "#ff9903"; //orange
export const BLACK = "#000000";
export const INCLUDEDWIP = "#d56f17";
export const NOTINCLUDEDWIP = "#2360e4";
export const SHAREDFIELD = "#bc13fe";
export const ALLREGISTEREDFIELD = "#595859";
export const ALLAVAILABLEFIELD = "#FFFFFF";
export const SFNOTINCLUDED = "#7af58b";
export const SFIMPACT = "#FFFF33";

export const COUNTY_AREA_BACKGROUND = [
  "#80808099",
  "#c8e6fd99",
  "#e587dd99",
  "#844bb599",
  "#75372e99",
  "#eccf9899",
  "#352f8899",
  "#81df5f99",
  "#5f6edd99",
  "#94885f99",
  "#e5b53599",
  "#6bddb999",
  "#c6740999",
  "#97c60999",
  "#ac1c1899",
  "#5c2b5f99",
];
export const CORN_SOYBEAN_BACKGROUND = ["#FFB23E99", "#C3E77699"];
export const CORN_SOYBEAN_LABELS = ["#93541B", "#73844F"];

export const SFHIGHIMPACT = "#f54b3b";
//Fluentd Logs
export const LOGNOTAPPLICABLE = "N/A";
export const LOGAUTHORISED = "authorized";
export const LOGUNAUTHORISED = "unauthorized";
export const LOGERROR = "Error";
export const LOGSUCCESS = "Success";
export const LOGERROR_LOGGING_LEVEL_ERROR = "5";
export const LOGERROR_LOGGING_LEVEL_SUCCESS = "4";
export const LOGSOURCE = "water-app-service";

//Email Templates
export const EMTCODE01 = "EMS10"; // Email to Admin for user already exist
export const EMTCODE02 = "EMS12"; // Email to Admin for Mobile phone number not registered
export const EMTCODE03 = "EMS20"; // Email to Admin from report section
export const EMTCODE04 = "EMS22"; // Email to Admin from well connection review request

export const EMPTY = "";
export const NONE = "None";
export const RELOAD_ONCE = "RELOAD_ONCE";
export const SKIP_WAITING = "SKIP_WAITING";

export const REMOVE_ON = "REMOVEON";
export const CHANGE_RIGHTS = "CHANGERIGHTS";
export const DUPLICATE_CROP = "DUPLICATECROP";
export const ACRES_EXECEEDED = "ACRESEXECEEDED";

export const USER_DETAILS = "USERDETAILS";
export const FIELDS = "FIELDS";
export const SHARED_FIELDS = "SHARED_FIELDS";
export const CROPS = "CROPS";
export const CLAIMS = "CLAIMS";
export const RESOURCES = "RESOURCES";

export const ADD_SHARE = "ADDSHARE";
export const DELETE_SHARE = "DELETESHARE";
export const REJECT_SHARE = "REJECTSHARE";

export const LAST_HOURS = "lastHours";
export const LAST_SEVEN_DAYS = "lastSevenDays";
export const LAST_THIRTY_DAYS = "lastThirtyDays";

export const USERNAME = "username";
export const REGISTERED_USER = "registeredUser";
export const STAFF_LOGGED_IN_USER = "staffLoggedInUser";
export const SESSION_EXPIRED_MESSAGE = "sessionExpiredMessage";
export const USER_POOL_GROUP = "userPoolGroup";
export const STAFF = "staff";
export const FARMER = "farmer";
export const CLAIM_IDS = "claim_ids";
export const SESSION_EXPIRED = "sessionExpired";
export const STAFF_SESSION_EXPIRED = "staffSessionExpired";
export const SUCCESSFUL_REGISTRATION = "sucessfullRegistration";
export const SHOW_STAFF_NOTES = "showStaffNotes";

export const NOT_AUTHORIZED_EXCEPTION = "NotAuthorizedException";
export const INVALID_PARAMETER_EXCEPTION = "InvalidParameterException";
export const LIMIT_EXCEEDED_EXCEPTION = "LimitExceededException";
export const USER_NOT_CONFIRMED_EXCEPTION = "UserNotConfirmedException";
export const CODE_MISMATCH_EXCEPTION = "CodeMismatchException";

export const LOGGING_IN = "logging_in";
export const LOGIN = "login";
export const LOGGING_OUT = "logging_out";
export const LOG_OUT = "logout";

export const DISPLAY_FIELD_OPTIONS = "display_field_options";
export const SHOW_BUSINESS = "show_business";
export const SHOW_FARM = "show_farm";
export const SHOW_FIELD = "show_field";
export const SEND_MAIL = "sendMail";

export const ADDED_FIELDS = "AddedFields";
export const REGISTERED_FIELDS = "RegisteredFields";
export const CLAIMED_FIELDS = "ClaimedFields";

export const DANGER = "danger";
export const INFO = "info";
export const WARNING = "warning";

export const MC001 = "MC001";
export const MC003 = "MC003";
export const MC004 = "MC004";
export const MC005 = "MC005";
export const MC006 = "MC006";

export const START_YEAR = 2016;
export const MAX_PROFILE_PICTURE_SIZE = 5 * 1024 * 1024;
export const DEBOUNCE_SEARCH_WAITING_TIME = 400;
export const DATE_FORMAT = "MM/dd/yyyy";
export const MAP_CENTER = [41.05414600000006, -100.67254699999995];
export const STATES = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "District of Columbia",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
];

export const NEBRASKA = "Nebraska";

export const MONTHS = [
  { value: "1", label: "January" },
  { value: "2", label: "February" },
  { value: "3", label: "March" },
  { value: "4", label: "April" },
  { value: "5", label: "May" },
  { value: "6", label: "June" },
  { value: "7", label: "July" },
  { value: "8", label: "August" },
  { value: "9", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];

export const MONTHS_ABBREVIATIONS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];

export const IRRIGATION_COMPANIES = [
  { label: "TPNRD", value: "TPNRD" },
  { label: "Downey", value: "Downey" },
  { label: "Gothenburg", value: "Gothenburg" },
  { label: "Grosch", value: "Grosch" },
  { label: "Sargent", value: "Sargent" },
  { label: "Sargent - Broken Bow", value: "Sargent - Broken Bow" },
];

export const COUNTY = [
  { label: "Arthur", value: "Arthur" },
  { label: "Keith", value: "Keith" },
  { label: "Lincoln", value: "Lincoln" },
  { label: "McPherson", value: "McPherson" },
];

export const PIPE_WALL_TYPE = [
  { label: "Aluminum", value: "Aluminum" },
  { label: "Steel", value: "Steel" },
  { label: "PVC", value: "PVC" },
];

//BASED ON ORDER OF EZ_ID
export const ELECTRIC_PROVIDERS = [
  { label: "Dawson PPD", value: "Dawson PPD", ez_id: "1" },
  { label: "Midwest PPD", value: "Midwest PPD", ez_id: "2" },
  { label: "North Platte", value: "North Platte", ez_id: "3" },
  { label: "Nebraska PPD", value: "Nebraska PPD", ez_id: "4" },
  { label: "Panhandle Rural", value: "Panhandle Rural", ez_id: "5" },
  { label: "NPPD-Sutherland", value: "NPPD-Sutherland", ez_id: "6" },
  { label: "Wheat Belt", value: "Wheat Belt", ez_id: "7" },
  { label: "Custer PPD", value: "Custer PPD", ez_id: "9" },
];

export const ELECTRIC_PROVIDERS_LIST = [
  {
    id: 1,
    name: "cppd",
    isActive: false,
    desc: "Custer Public Power District",
  },
  {
    id: 2,
    name: "dppd",
    isActive: false,
    desc: "Dawson Public Power District",
  },
  {
    id: 3,
    name: "mecc",
    isActive: false,
    desc: "Midwest Electric Coop Corp.",
  },
  {
    id: 4,
    name: "nppd",
    isActive: false,
    desc: "Nebraska Public Power District",
  },
  {
    id: 7,
    name: "npmlwd",
    isActive: false,
    desc: "North Platte Municipal Light & Water Dept.",
  },
  {
    id: 5,
    name: "prema",
    isActive: false,
    desc: "Panhandle Rural Electric Membership Assoc.",
  },
  {
    id: 6,
    name: "wbppd",
    isActive: false,
    desc: "Wheat Belt Public Power District",
  },
];

export const CUSTOM_WELL_FORM_SELECT_STYLES = {
  control: (provided) => ({
    ...provided,
    minHeight: "34px",
    height: "34px",
    marginTop: "1px",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "30px",
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: "13px",
  }),
  valueContainer: (provided) => ({
    ...provided,
    minHeight: "1px",
    height: "34px",
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: "13px",
  }),
  menuList: (provided) => ({
    ...provided,
    fontSize: "13px",
  }),
};

export const BAR_CHART_OPTIONS = {
  chart: {
    height: 350,
    type: "bar",
  },
  plotOptions: {
    bar: {
      horizontal: true,
    },
  },
  dataLabels: {
    enabled: false,
  },
  yaxis: {
    title: {
      text: "Days",
    },
  },
  xaxis: {
    categories: Array(15).fill(EMPTY),
    title: {
      text: "Water usage Inches/Acre",
    },
    labels: {
      formatter: (value) => parseFloat(value).toFixed(2),
    },
  },
};

export const COUNTY_AREAS = [
  "TP Avg",
  "GW-1",
  "GW-2",
  "GW-3",
  "GW-4",
  "GW-5",
  "GW-6",
  "GW-7",
  "GW-8",
  "GW-9",
  "GW-10",
  "GW-11",
  "GW-12",
  "GW-13",
  "GW-14",
  "GW-15",
];

export const AREA_INCH_OPTIONS_FOR_SEASONAL_AVERAGES = {
  plotOptions: {
    bar: {
      distributed: true,
      columnWidth: "90%",
    },
  },
  dataLabels: {
    enabled: true,
    style: {
      colors: ["#444444"],
      fontSize: "11px",
    },
  },
  yaxis: {
    title: {
      text: "Inches",
    },
  },
  xaxis: {
    categories: COUNTY_AREAS,
    labels: {
      rotate: -45,
      rotateAlways: true,
    },
  },
  colors: COUNTY_AREA_BACKGROUND,
  legend: {
    show: false,
  },
  responsive: [
    {
      breakpoint: 713,
      options: {
        dataLabels: {
          enabled: true,
          style: {
            fontSize: "8px",
          },
        },
        xaxis: {
          labels: {
            rotate: -45,
            rotateAlways: true,
          },
        },
      },
    },
  ],
};

export const CROP_INCH_OPTIONS_FOR_SEASONAL_AVERAGES = {
  plotOptions: {
    bar: {
      distributed: false,
      columnWidth: "90%",
    },
  },
  dataLabels: {
    enabled: true,
    style: {
      colors: CORN_SOYBEAN_LABELS,
      fontSize: "9px",
    },
  },
  xaxis: {
    categories: COUNTY_AREAS,
    labels: {
      rotate: -45,
      rotateAlways: true,
    },
  },
  colors: CORN_SOYBEAN_BACKGROUND,
  legend: {
    show: true,
    showForSingleSeries: true,
    offsetY: 7,
    customLegendItems: ["Corn", "Soybean"],
    markers: {
      fillColors: CORN_SOYBEAN_BACKGROUND,
    },
  },
  responsive: [
    {
      breakpoint: 1400,
      options: {
        dataLabels: {
          enabled: true,
          style: {
            fontSize: "8px",
          },
        },
      },
    },
    {
      breakpoint: 1200,
      options: {
        dataLabels: {
          enabled: true,
          style: {
            fontSize: "7px",
          },
        },
      },
    },
    {
      breakpoint: 991,
      options: {
        dataLabels: {
          enabled: true,
          style: {
            fontSize: "8px",
          },
        },
      },
    },
    {
      breakpoint: 833,
      options: {
        dataLabels: {
          enabled: true,
          style: {
            fontSize: "7px",
          },
        },
      },
    },
    {
      breakpoint: 713,
      options: {
        dataLabels: {
          enabled: false,
        },
      },
    },
  ],
};

export const LINE_CHART_OPTIONS = {
  colors: ["#ed7d31", "#4472c4"],
  dataLabels: {
    enabled: false,
    enabledOnSeries: undefined,
    textAnchor: "middle",
  },
  markers: {
    size: 6,
    hover: {
      size: 7,
    },
  },
  xaxis: {
    categories: MONTHS_ABBREVIATIONS,
    title: {
      text: "Months",
    },
  },
  yaxis: {
    title: {
      text: "Water usage Inches/Acre",
    },
  },
  legend: {
    position: "top",
    horizontalAlign: "center",
    floating: true,
    offsetY: 0,
    offsetX: -5,
  },
  fill: {
    opacity: 0.5,
  },
};

export const FIELD_TRANSFER_CUSTOM_STYLES = {
  header: {
    style: {
      textAlign: "left",
      padding: "5px",
      MinHeight: "50px",
    },
  },
  subHeader: {
    style: {
      textAlign: "left",
      padding: "5px",
    },
  },
  contextMenu: {
    style: {
      zIndex: "0",
    },
  },
};

export const TILLAGE_TYPES = {
  CTill: "Conventional Till",
  MTill: "Minimum Till",
  NTill: "No Till",
  STill: "Strip Till",
};

export const WELL_FORM_STEPS = [
  { title: "Tester Info" },
  { title: "Well Owner" },
  { title: "Well Info" },
  { title: "Irrigation Info" },
  { title: "Pump Rate" },
  { title: "Additional Info" },
];

export const FARMER_HEADER_OPTIONS = [
  { name: "Dashboard", value: "dashboard" },
  { name: "Field Registration", value: "map" },
  { name: "WDP Field Map", value: "farmer" },
  { name: "Crops", value: "crops" },
  { name: "Pump Rates", value: "pump-rates" },
  { name: "Seasonal Averages", value: "seasonal-averages" },
];

export const RICH_TEXT_EDITOR_PLUGINS = [
  "advlist",
  "autolink",
  "lists",
  "image",
  "charmap",
  "preview",
  "anchor",
  "searchreplace",
  "visualblocks",
  "code",
  "fullscreen",
  "insertdatetime",
  "media",
  "table",
  "code",
  "help",
  "wordcount",
];

export const PUMP_RATE_TYPE = {
  PON: "Pivot Only, Swing Arm & End gun off",
  PWS: "Pivot with Swing arm on, End gun off",
  PWE: "Pivot with End gun on, Swing arm off",
  PSE: "Pivot with Swing arm & End gun on",
  FLD: "Flood",
};

export const DASHBOARD_TABLE_CUSTOM_STYLES = {
  cells: {
    style: {
      fontSize: "12px",
    },
  },
  headCells: {
    style: {
      fontSize: "12px",
      marginLeft: "2px",
    },
  },
};
